import React, { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getIndicadores } from '../../services/IndicadoresService';
import './MenuIndicadores.css';

const MenuIndicadores = ({
    setDefaultUrl,
    setShowContenido,
    setNameView,
    setFichasJson,
    setNameArea,
    setNameTema

}) => {
    const [menuItems, setMenuItems] = useState([]);
    const [urlInicial, setUrlInicial] = useState('');
    const [error, setError] = useState(null);
    const [selectedIndicator, setSelectedIndicator] = useState(null);

    useEffect(() => {
        const fetchIndicadores = async () => {
            try {
                const { data } = await getIndicadores();
                const items = data.map((area, index) => ({
                    key: `area-${index}`,
                    label: area.area,
                    color: area.color,
                    children: area.temas.map((tema, temaIndex) => ({
                        key: `tema-${tema.tema_area_id}-${temaIndex}`,
                        label: tema.tema_area,
                        children: tema.indicadores.map((indicador, indicadorIndex) => ({
                            key: `indicador-${indicador.codigo_indicador}-${indicadorIndex}`,
                            label: indicador.descripcion,
                            url: indicador.url,
                            name_view: indicador.name_view || 'default',
                            fichas_json: indicador.fichas_json,
                            areaColor: area.color,
                        })),
                    })),
                }));

                setMenuItems(items);

                if (
                    items.length > 0 &&
                    items[0].children.length > 0 &&
                    items[0].children[0].children.length > 0
                ) {
                    const primeraUrl = items[0].children[0].children[0].url;
                    setUrlInicial(primeraUrl);
                    setDefaultUrl(primeraUrl);
                }
            } catch (error) {
                console.error('Error al obtener indicadores:', error);
                setError('Error al cargar los indicadores');
            }
        };

        fetchIndicadores();
    }, [setDefaultUrl, setShowContenido, setNameView, setFichasJson]);

    const handleItemClick = (
        url,
        name_view,
        fichas_json,
        indicatorKey,
        areaColor,
        area,
        tema
    ) => {
        setDefaultUrl(url);
        setShowContenido(true);
        setNameView(name_view);
        setFichasJson(fichas_json);
        setSelectedIndicator(indicatorKey);
        setShowContenido(true);
        setNameArea(area);
        setNameTema(tema)
    };

    return (
        <div className="menu-indicadores">
            {error && <p>{error}</p>}
            {menuItems.map((area) => (
                <div key={area.key} className="area-container">
                    <h3 className="area-title">{area.label}</h3>
                    <List>
                        {area.children.map((tema) => (
                            <Accordion key={tema.key} className='acordeon-tema'>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon className="custom-expand-icon" />}
                                    style={{ backgroundColor: area.color }}
                                >
                                    <ListItemText
                                        primary={tema.label}
                                        classes={{ primary: 'tema-title'}}
                                    />
                                </AccordionSummary>
                                <AccordionDetails className='acordeon-indicador'>
                                    <List>
                                        {tema.children.map((indicador) => (
                                            <ListItem
                                                key={indicador.key}
                                                onClick={() =>
                                                    handleItemClick(
                                                        indicador.url,
                                                        indicador.name_view,
                                                        indicador.fichas_json,
                                                        indicador.key,
                                                        indicador.areaColor,
                                                        area.label,
                                                        tema.label
                                                        
                                                    )
                                                }
                                                style={{
                                                    backgroundColor:
                                                        selectedIndicator === indicador.key
                                                            ? indicador.areaColor
                                                            : 'transparent',
                                                    color:
                                                        selectedIndicator === indicador.key
                                                            ? '#fff'
                                                            : 'inherit',
                                                    cursor: 'pointer',
                                                    fontSize: '8rem'
                                                }}
                                            >
                                                <ListItemText primary={indicador.label} classes={{ primary: 'indicador-title' }}/>
                                            </ListItem>
                                        
                                        ))}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </List>
                </div>
            ))}
        </div>
    );
};

export default MenuIndicadores;
